// Header.js
import React, { useContext, useEffect, useState } from "react";
import "./Header.css";
import { Link, useNavigate } from "react-router-dom";
import { clearAuthData } from "../../utils/AuthStorage";
import Loading from "../Loading";
import axios from "axios";
import { useVendor } from "../../utils/Context";
import toast, { Toaster } from 'react-hot-toast';
import { FaCog } from "react-icons/fa";
import { getPermissionByPrefix } from "../../utils/permissions";
import { FaRegCircleUser } from "react-icons/fa6";
import { useErrorToast } from "../../hooks/useErrorToast";
import { IoIosInformationCircleOutline } from "react-icons/io";
import { Tooltip } from "@mui/material";
import { Dialog, DialogContent, DialogTitle, Button } from "@mui/material";

const Header = ({ toggleSidebar, showSidebarToggle }) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const showError = useErrorToast();
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const { selectedVendor, setSelectedVendor, vendors, setVendors } =
    useVendor();
      const logPermission = getPermissionByPrefix("log_activity");
        const vendorPermission = getPermissionByPrefix("manage_vendor");

  const handleLogout = () => {
    clearAuthData();
    navigate("/");
  };

  useEffect(() => {
 if (vendorPermission?.is_view) {
    handleVendor();
  }
  }, []);

  const handleVendor = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("tokenInv");
      const response = await axios.get(`${process.env.REACT_APP_URL}/vendors`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "ngrok-skip-browser-warning": "true",
        },
      });
      setVendors(response.data);
      if (response.data.length > 0) {
        setSelectedVendor(response.data[0].id);
      }
      if (response.data.length == 0) {
        setSelectedVendor(-1);
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        showError("Session Expired! Please Login");
        localStorage.removeItem("tokenInv");
        localStorage.removeItem("roleInv");
        navigate("/");
      } else {
        // toast.error(error?.response?.data?.msg || "Something went wrong. Please try again.");
        showError(error?.response?.data?.msg || "Something went wrong. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };
  
const userName = localStorage.getItem("userName")
const userRole = localStorage.getItem("userRole")
  return (
    <>
<Toaster position="top-right" reverseOrder={false}/>

      <header style={headerStyle}>
        {loading && <Loading />}
        <div style={logoContainerStyle}>
          {showSidebarToggle && (
          <button style={hamburgerStyle} onClick={toggleSidebar}>
            &#9776;
          </button>
          )}
          <div className="logo">
            <img
              src="https://login.thepresence360.com/images/thepresence.png"
              alt="Logo"
              style={{ height: "40px" }}
            />
          </div>
        </div>

        <nav style={navStyle}>
                   <Tooltip title="View Workflow Process">
                  <span
                    onClick={handleOpen}
                    style={{
                      cursor: "pointer",
                      alignContent:"center",
                      marginTop:"4px",
                    }}
                  >
                    <IoIosInformationCircleOutline size={25}/>
                  </span>
                </Tooltip>
          {vendorPermission.is_view && (
          <div style={dropdownContainerStyle}>
            <select
              value={selectedVendor}
              onChange={(e) => setSelectedVendor(e.target.value)}
              style={dropdownStyle}
            >
              {vendors.map((el) => (
                <option value={el.id}>{el.name}</option>
              ))}
              <option value="NTT">NTT</option>
            </select>
          </div>)}

          <div style={profileContainerStyle} className="profile-dropdown">

  <FaRegCircleUser style={profileIconStyle}/> 
  <div className="dropdown-content">
    <div onClick={() => navigate("/profile")} className="dropdown-item">Profile</div>
    {logPermission.is_view && (
      <div onClick={() => navigate("/logs")} className="dropdown-item">Activity</div>
    )}
    <div onClick={handleLogout} className="dropdown-item">Logout</div>
  </div>
</div>
<div style={{fontWeight:"500"}}>{userName}
  <span style={{paddingLeft:"5px"}}>({userRole})</span>
</div>

        </nav>
      </header>

        <Dialog open={open} onClose={handleClose} maxWidth="lg" fullWidth style={{zIndex:"9999999"}}>
        <DialogTitle>Workflow Process</DialogTitle>
        <DialogContent style={{ display: "flex", justifyContent: "center", padding: "16px" }}>
          <img
            src="./process1.png"
            alt="Workflow Process"
            style={{ maxWidth: "100%", maxHeight: "70vh", objectFit: "contain" }}
          />
          
        </DialogContent>
        <div style={{ display: 'flex', alignSelf: 'center' }}>
                    
                    <Button
                      variant="contained"
                      color="error"
                      onClick={handleClose}
                      sx={{
                        mt: 2,
                        alignSelf: 'center',
                        width: '150px', marginBottom:"20px"
                      }}
                    >
                      Close
                    </Button>
                  </div>
      </Dialog>
    </>
  );
};

const headerStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  background: "#7C2EA0",
  position: "fixed",
  width: "100%",
  boxSizing: "border-box",
  height: "70px",
  padding: "10px 20px",
  color: "#fff",
  zIndex: "1100",
};

const logoContainerStyle = {
  display: "flex",
  alignItems: "center",
  gap: "10px",
};

const hamburgerStyle = {
  fontSize: "24px",
  background: "none",
  border: "none",
  color: "#fff",
  cursor: "pointer",
};

const navStyle = {
  display: "flex",
  gap: "15px",
  alignItems: "center",
};

const dropdownContainerStyle = {
  position: "relative",
};

const dropdownStyle = {
  padding: "8px 12px",
  fontSize: "16px",
  borderRadius: "8px",
  border: "none",
  background: "#fff",
  color: "#333",
  cursor: "pointer",
  outline: "none",
  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
  transition: "all 0.3s ease-in-out",
};

dropdownStyle[":hover"] = {
  background: "#f0f0f0",
};

dropdownStyle[":focus"] = {
  border: "2px solid #7C2EA0",
};

const linkStyle = {
  color: "#fff",
  textDecoration: "none",
  fontSize: "16px",
  cursor: "pointer",
};

const profileContainerStyle = {
  position: "relative",
  cursor: "pointer",
};

const profileIconStyle = {
  width: "32px",
  height: "32px",
  borderRadius: "50%",
  objectFit: "cover",
};


export default Header;
